import { createSlice } from '@reduxjs/toolkit';

import { BookingBusinessDetailsResponse, InfoMeetingServiceDetailsResponse, V0MeetingServiceDetailsResponse, V1ServiceDetailsResponse, V2ServiceDetailsResponse, V3ServiceDetailsResponse, V4ServiceDetailsResponse } from 'utils/BookingAPI';

import type { DayId } from 'config/meetingTypes';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface BookingEntry {
    dayId: DayId;
    title: string;
    date: string;
    duration: string;
    location: string;
}

export type ServiceDetailsMap = Partial<Record<DayId, InfoMeetingServiceDetailsResponse | V0MeetingServiceDetailsResponse | V1ServiceDetailsResponse | V2ServiceDetailsResponse | V3ServiceDetailsResponse | V4ServiceDetailsResponse>>;

export interface BookingState {
    bookings: Record<DayId, BookingEntry | null>; // keyed by dayId e.g. V1,V2
    serviceDetails: ServiceDetailsMap;
    BookingBusinessDetails: BookingBusinessDetailsResponse | null;
}

const initialState: BookingState = {
    bookings: { INFO: null, V0: null, V1: null, V2: null, V3: null, V4: null },
    serviceDetails: {},
    BookingBusinessDetails: null,
};

export const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setBooking: (state, action: PayloadAction<BookingEntry>) => {
            state.bookings[action.payload.dayId] = action.payload;
        },
        resetBooking: (state, action: PayloadAction<{ dayId: DayId }>) => {
            state.bookings[action.payload.dayId] = null;
        },
        setServiceDetails: (state, action: PayloadAction<{ key: keyof ServiceDetailsMap; details: ServiceDetailsMap[keyof ServiceDetailsMap] }>) => {
            state.serviceDetails[action.payload.key] = action.payload.details;
        },
        setBookingBusinessDetails: (state, action: PayloadAction<BookingBusinessDetailsResponse>) => {
            state.BookingBusinessDetails = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setBooking, resetBooking, setServiceDetails, setBookingBusinessDetails } = bookingSlice.actions;

export default bookingSlice.reducer;